import { apiClient } from './client';
import type { PaginatedResponse, PaginationParams, MessageResponse } from '../types/api';
import type { AdminFeatureFlagItem, AdminFeatureFlagDetail, AdminFeatureFlagCreateRequest, AdminFeatureFlagUpdateRequest, AdminAuditLogItem, AdminAuditLogDetail, SystemHealthResponse, SystemMetricsResponse } from '../types/system';

export const systemApi = {
  listFeatureFlags: () =>
    apiClient.get<AdminFeatureFlagItem[]>('/system/feature-flags').then((r) => r.data),
  createFeatureFlag: (data: AdminFeatureFlagCreateRequest) =>
    apiClient.post<AdminFeatureFlagDetail>('/system/feature-flags', data).then((r) => r.data),
  updateFeatureFlag: (id: string, data: AdminFeatureFlagUpdateRequest) =>
    apiClient.patch<AdminFeatureFlagDetail>(`/system/feature-flags/${id}`, data).then((r) => r.data),
  deleteFeatureFlag: (id: string) =>
    apiClient.delete<MessageResponse>(`/system/feature-flags/${id}`).then((r) => r.data),

  listAuditLogs: (params: PaginationParams & { admin_id?: string; action?: string; target_type?: string }) =>
    apiClient.get<PaginatedResponse<AdminAuditLogItem>>('/system/audit-logs', { params }).then((r) => r.data),
  auditLogDetail: (id: string) =>
    apiClient.get<AdminAuditLogDetail>(`/system/audit-logs/${id}`).then((r) => r.data),

  health: () =>
    apiClient.get<SystemHealthResponse>('/system/health').then((r) => r.data),
  metrics: () =>
    apiClient.get<SystemMetricsResponse>('/system/metrics').then((r) => r.data),
};
